import { FooterResponsive } from '../Footer/FooterResponsive'
import { FooterQueryFragment } from './FooterQueryFragment.gql'

export type FooterProps = FooterQueryFragment

export function Footer(props: FooterProps) {
  return <FooterResponsive {...props} />
}
